<template>
  <div>
    <DefaultLayout>
      <template #mainHeader>
        <InhousePortalHeader />
      </template>
      <template #page="{ layoutParams }">
        <TableLayout
          :layoutParams="layoutParams"
          :hideFooter="searchParams.pageCount >= searchParams.total_item"
        >
          <template #tableHeader="{ updateHeader }">
            <TableHeader
              ref="tableHeader"
              :addButtonTitle="TITLE_BTN_ADD"
              :pageTitle="setPageTitle"
              :multiRemoveStatus="disableRemoveBtn"
              :updateHeader="updateHeader"
              :isSetting="isSetting"
              :isDelete="isDelete"
              :isSearch="false"
              :isAddNew="false"
              @openRemoveDialog="openRemoveDialog"
              @openDiaLogSetting="openSettingMachineDialog"
            >
            </TableHeader>
            <SearchFormWrapper>
              <SelectWithFilter
                class="search width-middle"
                placeholder="元請会社"
                name="company_id"
                :values="searchInputs"
                :items="mainContractorCompanyList"
                :editable="true"
                :readonly="!isAdminOrPatner"
                validation_label="元請会社"
                @onInput="onChangeSearchInputs"
              />
              <SelectWithFilter
                class="search width-middle"
                placeholder="大分類"
                name="major_classification_id"
                :items="MAJOR_ITEM"
                item_text="major_classification"
                item_value="major_classification_id"
                :editable="true"
                :values="searchInputs"
                @onInput="onChangeSearchInputs"
              />
              <SelectWithFilter
                class="search width-middle"
                placeholder="機械名"
                name="classification_id"
                item_text="middle_classification"
                item_value="classification_id"
                :items="MEDIUM_ITEM"
                :editable="true"
                :values="searchInputs"
                @onInput="onChangeSearchInputs"
              />
              <v-btn class="search" color="primary" @click="onSearch">
                検索
              </v-btn>
            </SearchFormWrapper>
            <TableSortWrapper>
              <TableSort
                :values="searchParams"
                :sort_items="SORT_ITEMS"
                sort_item_text="name"
                sort_item_value="id"
                :page_counts_options="PAGE_COUNT_OPTIONS"
                :sort_order_options="SORT_ORDERS"
                :total_item="searchParams.total_item"
                @onInput="onChangeSortParams"
              />
            </TableSortWrapper>
          </template>
          <template #tableBody="{ tableHeight }">
            <v-data-table
              v-model="selectedItems"
              :headers="TABLE_LABELS"
              :items="machineList"
              :items-per-page="searchParams.pageCount"
              :height="tableHeight"
              fixed-header
              hide-default-footer
              disable-sort
              sort-by="updatedAt"
              show-select
              noDataText="データがありません。"
              item-key="id"
            >
              <template v-slot:[`item.name`]="{ item }">
                <div>
                  {{ convertName(item.name, 60) }}
                </div>
              </template>
            </v-data-table>
          </template>
          <template #tableFooter>
            <Pagination
              :current="searchParams.currentPage"
              :total="searchParams.totalPage"
              @pageUpdate="pageUpdate"
            />
          </template>
        </TableLayout>
      </template>
    </DefaultLayout>
    <Popup :dialog="popups.isShowItemForm">
      <MachineForm :isNewItem="isNewItem" @cancel="closeItemForm" />
    </Popup>
    <Popup width="650px" :dialog="popups.isShowRemoveDialog">
      <ConfirmDialog
        @close="closeRemoveDialog()"
        @yes="removeItems()"
        :isDelete="true"
        :isMachineDetails="true"
        title="選択項目の削除"
        text="以下を削除してもよろしいですか？"
        :items="selectedItems"
      />
    </Popup>
    <Popup width="90%" :dialog="popups.isShowDialogSettingMachine">
      <DialogSettingMachine @close="closeRemoveDialogSetting()" />
    </Popup>
    <Popup width="640px" :dialog="popups.isShowNoticeDialog">
      <NotificationDialog
        @close="closeNoticeDialog"
        :date="popups.maintainDate"
        :time="popups.maintainTime"
        :message="popups.messageDialog"
      />
    </Popup>
    <Loader :isLoading="isLoading"></Loader>
  </div>
</template>

<script>
import { Store } from "@/store/Store.js";
import { getFullCompanyName } from "@/utils/common";
import {
  TABLES_PER_PAGE,
  TABLE_SORT_ORDERS,
  COMPANY_TYPE,
} from "@/constants/COMMON";
import {
  MACHINE_TABLE_LABELS,
  MACHINE_SORT_ITEMS,
  MACHINE_INITAL_ITEM,
  OWNER_MACHINE_FLG,
} from "@/constants/MACHINES";
import { COMPANY_TYPE_MAIN_CONTRACTOR } from "@/constants/COMPANY";
import { HEADER_MENU_ITEMS_INHOUSE } from "@/constants/GLOBALHEADER";
import DialogSettingMachine from "@/views/master/machines/dialog-content/DialogSettingMachine";

// Components
import DefaultLayout from "@/components/layout/DefaultLayout";
import TableLayout from "@/components/layout/TableLayout";
import TableHeader from "@/components/forms/elements/TableHeader";
import Pagination from "@/components/forms/elements/Pagination";
import SearchFormWrapper from "@/components/forms/elements/SearchFormWrapper";
import TableSortWrapper from "@/components/forms/elements/TableSortWrapper";
import TableSort from "@/components/forms/elements/TableSort";
import InhousePortalHeader from "@/components/globalHeader/InhousePortalHeader";
import Popup from "@/components/common/Popup";
import Loader from "@/components/forms/elements/Loader";
import ConfirmDialog from "@/components/dialog/ConfirmDialog";
import NotificationDialog from "@/components/dialog/NotificationDialog";
import InputText from "@/components/forms/elements/InputText";
import Label from "@/components/forms/elements/Label";
import MachineForm from "@/components/forms/machines/MachineForm";
import SelectWithFilter from "@/components/forms/elements/SelectWithFilter";

// 定数
const PAGE_TITLE = "登録機械一覧";
const TABLE_LABELS = MACHINE_TABLE_LABELS;
const PAGE_COUNT_OPTIONS = TABLES_PER_PAGE;
const SORT_ORDERS = TABLE_SORT_ORDERS;
const SORT_ITEMS = MACHINE_SORT_ITEMS;
const STORE = "Machines";
const PAGE_COUNT = 25;
const INITIAL_ITEM = MACHINE_INITAL_ITEM;
const TITLE_BTN_ADD = "新規作成";

export default {
  head: {
    title() {
      return { inner: "", separator: " ", complement: PAGE_TITLE };
    },
  },
  components: {
    DialogSettingMachine,
    DefaultLayout,
    TableLayout,
    TableHeader,
    Pagination,
    SearchFormWrapper,
    TableSortWrapper,
    TableSort,
    InhousePortalHeader,
    Popup,
    Loader,
    ConfirmDialog,
    Label,
    InputText,
    MachineForm,
    NotificationDialog,
    SelectWithFilter,
  },
  data() {
    return {
      TITLE_BTN_ADD,
      PAGE_TITLE,
      SORT_ITEMS,
      TABLE_LABELS,
      MEDIUM_ITEM: [],
      MAJOR_ITEM: [],
      SORT_ORDERS,
      PAGE_COUNT_OPTIONS,
      COMPANY_TYPE,
      editedItem: { ...INITIAL_ITEM },
      mainContractorCompanyList: [],
      items: [],
      selectedItems: [],
      isLoading: false,
      // searchParams
      searchParams: {
        pageCount: PAGE_COUNT,
        sort: null,
        asc: true,
        currentPage: 1,
        totalPage: 1,
      },
      // searchInputs
      searchInputs: {
        company_id: null,
        major_classification_id: null,
        middle_classification_id: null,
      },
      popups: {
        isShowItemForm: false,
        isShowRemoveDialog: false,
        isShowDialogSettingMachine: false,
        isShowNoticeDialog: false,
        messageDialog: "",
        maintainDate: "",
        maintainTime: "",
      },
      machineForm: {
        editable: false,
      },
      isNewItem: false,
      machine_id: null,
    };
  },
  watch: {
    searchInputs(newValue, oldValue) {
      if (newValue.company_id !== oldValue.company_id) this.onSearch();
    },
    loginUser() {
      if (!this.isPatner) {
        this.getDataCompany();
      } else {
        this.getListCompanyUsersField();
      }
    },
  },
  computed: {
    loginUser() {
      return Store.state.Login.user;
    },
    companyType() {
      return this.loginUser?.company_type;
    },
    setPageTitle() {
      const companyName = getFullCompanyName(
        this.loginUser.corporate_type,
        this.loginUser.company_name
      );
      if (
        this.companyType === COMPANY_TYPE.ADMIN ||
        this.companyType === COMPANY_TYPE.PARTNER
      ) {
        return PAGE_TITLE;
      } else {
        return [this.loginUser.corporate_number, companyName, PAGE_TITLE].join(
          "\u00A0\u00A0\u00A0\u00A0"
        );
      }
    },
    disableRemoveBtn() {
      return this.selectedItems.length === 0;
    },
    apiParams() {
      return {
        major_classification_id: this.searchParams.major_classification_id,
        middle_classification_id: this.searchParams.middle_classification_id,
        company_id: this.searchParams.company_id,
        name: this.searchParams.word,
        sort_value: this.searchParams.sort,
        sort_by: this.searchParams.asc ? 1 : 0,
        page_number: this.searchParams.currentPage,
        page_size: this.searchParams.pageCount,
      };
    },
    isAdminOrPatner() {
      if (
        this.companyType == COMPANY_TYPE.ADMIN ||
        this.companyType == COMPANY_TYPE.PARTNER
      ) {
        return true;
      }
      return false;
    },
    isAdmin() {
      if (this.companyType == COMPANY_TYPE.ADMIN) {
        return true;
      }
      return false;
    },
    isOwner() {
      if (this.companyType == COMPANY_TYPE.OWNER) {
        return true;
      }
      return false;
    },
    isPatner() {
      if (this.companyType == COMPANY_TYPE.PARTNER) {
        return true;
      }
      return false;
    },
    isSetting() {
      return this.companyType == COMPANY_TYPE.ADMIN || this.loginUser.role == 9;
    },
    isDelete() {
      return this.companyType == COMPANY_TYPE.ADMIN;
    },
    machineList() {
      if (this.companyType === COMPANY_TYPE.OWNER) {
        return this.items.map((x) => ({
          ...x,
          isSelectable: x?.own_machine_flg === OWNER_MACHINE_FLG,
        }));
      } else {
        return this.items;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  async mounted() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };

    this.getNotification();
    Store.dispatch("GlobalHeader/setInHouseMenu", {
      menuId: HEADER_MENU_ITEMS_INHOUSE.MACHINES.id,
    });
    Store.dispatch("GlobalHeader/setSite", {
      field_id: null,
    });
    if (!this.isPatner) {
      this.getDataCompany();
    } else {
      await this.getListCompanyUsersField();
    }
    this.getListMajorInspection();
    this.getListMediumInspection();
    this.getItems();
    this.$watch(
      () => [
        Store.getters[`${STORE}/getData`],
        Store.getters[`${STORE}/getPagination`],
      ],
      (data) => {
        this.items = data[0];
        let searchParams = { ...this.searchParams };
        searchParams.totalPage = data[1].total;
        searchParams.currentPage = data[1].current;
        searchParams.total_item = data[1].total_item;
        this.searchParams = searchParams;
      },
      {
        immidiate: true,
        deep: true,
      }
    );
    this.$watch(
      () => Store.state.Company.data,
      (data) => {
        this.mainContractorCompanyList = [...data];
        if (!this.isAdminOrPatner) {
          this.searchInputs.company_id = this.mainContractorCompanyList.find(
            (company) => company.id === this.loginUser.company_id
          )?.id;
        } else {
          this.searchInputs.company_id = this.mainContractorCompanyList[0].id;
        }
        this.onSearch();
      },
      {
        immediate: false,
        deep: true,
      }
    );
  },
  methods: {
    async getDataCompany() {
      let apiParams = { company_type: [COMPANY_TYPE_MAIN_CONTRACTOR] };
      await Store.dispatch(`Company/get`, apiParams);
    },
    async getListCompanyUsersField() {
      const result = await Store.dispatch(`Company/getListCompanyUsersField`);
      this.mainContractorCompanyList = [...result];
      this.searchInputs.company_id = this.mainContractorCompanyList[0]["id"];
      this.searchParams = { ...this.searchParams, ...this.searchInputs };
    },
    onSearch() {
      this.searchParams = { ...this.searchParams, ...this.searchInputs };
      this.searchParams["currentPage"] = 1;
      this.$nextTick(() => {
        this.selectedItems = [];
      });
      this.getItems();
    },
    openRemoveDialog() {
      this.popups.isShowRemoveDialog = true;
    },
    openSettingMachineDialog() {
      this.popups.isShowDialogSettingMachine = true;
    },
    closeRemoveDialog() {
      this.$nextTick(() => {
        this.selectedItems = [];
      });
      this.popups.isShowRemoveDialog = false;
    },
    closeRemoveDialogSetting() {
      this.popups.isShowDialogSettingMachine = false;
      this.getItems();
      this.getListMajorInspection();
      this.getListMediumInspection();
    },
    onChangeSortParams({ name, value }) {
      let searchParams = { ...this.searchParams };
      searchParams[name] = value;
      this.searchParams = searchParams;
      this.getItems();
    },
    onChangeSearchInputs({ name, value }) {
      let searchInputs = { ...this.searchInputs };
      if (name == "classification_id") {
        if (value) {
          const [majorValue, middleValue] = value.split("-").map(Number);
          searchInputs["classification_id"] = value;
          searchInputs["middle_classification_id"] = middleValue;
          searchInputs["major_classification_id"] = majorValue;
        } else {
          searchInputs["classification_id"] = null;
          searchInputs["middle_classification_id"] = null;
        }
      } else if (name == "major_classification_id") {
        searchInputs["major_classification_id"] = value;
        this.getListMediumInspection(value);
        searchInputs["middle_classification_id"] = null;
      } else {
        searchInputs[name] = value;
      }
      this.searchInputs = searchInputs;
    },
    pageUpdate(n) {
      let searchParams = { ...this.searchParams };
      searchParams.currentPage = n;
      this.searchParams = searchParams;
      this.getItems();
    },
    openNewItemForm() {
      this.isNewItem = true;
      this.popups.isShowItemForm = true;
    },
    async openItemForm(item) {
      const machineInfo = await Store.dispatch(
        `${STORE}/getMachineDetail`,
        item.id
      );
      if (!machineInfo.hasError) {
        this.machine_id = item.id;
        this.isNewItem = false;
        this.popups.isShowItemForm = true;
      }
    },
    closeItemForm() {
      this.popups.isShowItemForm = false;
      this.getItems();
    },
    async removeItems() {
      const machine_ids = this.selectedItems.map((items) => items.id);
      const result = await Store.dispatch(`${STORE}/delete`, { machine_ids });
      if (!result.hasError) {
        this.getItems();
        Store.dispatch("Toast/show", {
          status: 200,
          message: "削除しました",
        });
      }
      this.closeRemoveDialog();
    },
    async getItems() {
      this.isLoading = true;
      await Store.dispatch(`${STORE}/get`, this.apiParams);
      this.isLoading = false;
    },
    async getListMajorInspection() {
      let apiParams = {
        main_contractor_id: this.loginUser?.main_contractor_id,
      };
      const response = await Store.dispatch(
        `CmnMst/getListMajorInspection`,
        apiParams
      );
      if (!response.hasError) {
        const { entries } = response.data.contents;
        this.MAJOR_ITEM = [...entries];
        this.MAJOR_ITEM.unshift({
          major_classification_id: null,
          major_classification: "",
        });
      }
    },
    async getListMediumInspection(id) {
      let apiParams = {
        main_contractor_id: this.loginUser?.main_contractor_id,
      };
      if (id) {
        apiParams["major_classification_id"] = id;
        const response = await Store.dispatch(
          `CmnMst/getListMediumInspection`,
          apiParams
        );
        if (!response.hasError) {
          const { entries } = response.data.contents;
          this.MEDIUM_ITEM = [...entries];
          this.MEDIUM_ITEM.unshift({
            classification_id: null,
            middle_classification: "",
          });
        }
      } else {
        const response = await Store.dispatch(
          `CmnMst/getListMediumInspection`,
          apiParams
        );
        if (!response.hasError) {
          const { entries } = response.data.contents;
          this.MEDIUM_ITEM = [...entries];
          this.MEDIUM_ITEM.unshift({
            middle_classification_id: null,
            middle_classification: "",
          });
        }
      }
    },
    convertName(name, length) {
      let result = "";
      if (name) {
        result = name;
        if (name.length > length) {
          result = name.substring(0, length) + "•••";
        }
      }
      return result;
    },
    async getNotification() {
      const STORAGE_KEY = "LOGGED_IN";
      if (this.prevRoute.path == "/") {
        const response = await Store.dispatch(`CmnMst/getNotification`);
        if (!response.hasError) {
          const { entries } = response.data.contents;
          if (entries !== null) {
            this.NOTIFICATION = entries.id;
            let notifyId = JSON.parse(
              localStorage.getItem(STORAGE_KEY) || "[]"
            );
            if (!notifyId.includes(this.NOTIFICATION)) {
              this.popups.isShowNoticeDialog = true;
              this.popups.maintainDate = entries.date;
              this.popups.maintainTime = entries.time;
              this.popups.messageDialog = entries.content;
            }
          }
        }
      }
    },
    closeNoticeDialog(status) {
      const STORAGE_KEY = "LOGGED_IN";
      if (status) {
        let notifyId = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
        notifyId.push(this.NOTIFICATION);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(notifyId));
      }
      this.popups.isShowNoticeDialog = false;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .v-slide-group__wrapper {
  max-width: 100%;
  overflow-x: auto;
  white-space: nowrap;
}
</style>
